/**
 * oddit-announcement-bar — Rotating announcement messages
 */
(function () {
  'use strict';

  function initAnnouncementBar(section) {
    var wrapper = section.querySelector('.oddit-announcement-bar__wrapper');
    var blocksContainer = section.querySelector('.js-announcement-blocks');
    var blocks = section.querySelectorAll('.js-announcement-block');

    if (!wrapper || !blocksContainer || blocks.length <= 1) return;

    var autoplayIntervalId = null;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function getActiveIndex() {
      var activeBlock = section.querySelector('.js-announcement-block.is-active');
      if (!activeBlock) return 0;
      return Array.prototype.indexOf.call(blocks, activeBlock);
    }

    function updateAnnouncementHeight() {
      var activeBlock = section.querySelector('.js-announcement-block.is-active');
      if (activeBlock) {
        blocksContainer.style.height = activeBlock.offsetHeight + 'px';
      }

      document.documentElement.style.setProperty(
        '--s-announcement-dynamic',
        section.offsetHeight + 'px'
      );
    }

    function updateActiveMessage(index) {
      blocks.forEach(function (block, i) {
        block.classList.toggle('is-active', i === index);
      });

      updateAnnouncementHeight();
      document.dispatchEvent(new CustomEvent('oddit-announcement:change'));
    }

    function navigate(direction) {
      var currentIndex = getActiveIndex();
      var total = blocks.length;
      var newIndex;

      if (direction === 'prev') {
        newIndex = currentIndex > 0 ? currentIndex - 1 : total - 1;
      } else {
        newIndex = currentIndex < total - 1 ? currentIndex + 1 : 0;
      }

      updateActiveMessage(newIndex);
    }

    function stopAutoplay() {
      if (autoplayIntervalId) {
        clearInterval(autoplayIntervalId);
        autoplayIntervalId = null;
      }
    }

    function startAutoplay() {
      if (prefersReducedMotion || !wrapper.dataset.autoplay) return;

      var intervalSeconds = parseInt(wrapper.dataset.autoplayInterval, 10);
      if (!intervalSeconds || intervalSeconds <= 0) return;

      stopAutoplay();
      autoplayIntervalId = setInterval(function () {
        if (section.classList.contains('is-autoplay-disabled')) return;
        navigate('next');
      }, intervalSeconds * 1000);
    }

    section.addEventListener('mouseenter', function () {
      section.classList.add('is-autoplay-disabled');
    });

    section.addEventListener('mouseleave', function () {
      section.classList.remove('is-autoplay-disabled');
    });

    section.addEventListener('click', function (event) {
      var nav = event.target.closest('[data-announcement-nav]');
      if (!nav) return;

      navigate(nav.dataset.announcementNav);
      stopAutoplay();
    });

    updateAnnouncementHeight();
    startAutoplay();

    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(function () {
        updateAnnouncementHeight();
      });
      blocks.forEach(function (block) {
        resizeObserver.observe(block);
      });
    } else {
      window.addEventListener('resize', updateAnnouncementHeight);
    }
  }

  function init() {
    document.querySelectorAll('.oddit-announcement-bar').forEach(initAnnouncementBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
